"use strict";
var lib_core = require("lib-core");
if(typeof window !== 'undefined')
    var ui_extensions = require("ui-extensions");

var SnapSet = require("./../extensions/snap/snapSet.js");
var SnapLineType = require("./../extensions/snap/snapLineType.js");
var AbstractSelectableInteractionModel = require("./abstractSelectableInteractionModel.js");
var cio_config = require("cio-config");

var AbstractPosInteractionModel = function (data, editorModel, options) {
    var self = this;
    AbstractSelectableInteractionModel.call(this, data, editorModel);
    this.origin = (editorModel.origin)? editorModel.origin(): null;
    this.options = options || {};

    // shadows for inspector: terminal properties with respect to the origin
    if (this.origin) {
        this.showX = this.shadow("showX",
            function () {
                return self.origin.getCoordRelative(self.data.pos()).x;
            },
            function (value) {
                var new_pos = self.data.pos().copy();
                new_pos.x = self.origin.convertX(value);
                return self.data.pos(new_pos);
            },
            [this.data.pos, [this.origin, this.origin.onBubble]]
        );

        this.showY = this.shadow("showY",
            function () {
                return self.origin.getCoordRelative(self.data.pos()).y;
            },
            function (value) {
                var new_pos = self.data.pos().copy();
                new_pos.y = self.origin.convertY(value);
                return self.data.pos(new_pos);
            },
            [[this.data.pos, this.data.pos.onChange],
             [this.origin, this.origin.onBubble]]
        );
    }
};
lib_core.inherit(AbstractPosInteractionModel, AbstractSelectableInteractionModel);

module.exports = AbstractPosInteractionModel;

AbstractPosInteractionModel.prototype.getInspectorElements = function () {
    var inspectorElements = {};

    inspectorElements.input_elements = [
        {
            label      : 'X',
            type       : ui_extensions.InspectorInputType.VALUE_AND_FIXEDUNIT,
            datamember : this.showX,
            datatype   : cio_config.types.float,
            unitmember : this.origin.showUnitString
        },
        {
            label      : 'Y',
            type       : ui_extensions.InspectorInputType.VALUE_AND_FIXEDUNIT,
            datamember : this.showY,
            datatype   : cio_config.types.float,
            unitmember : this.origin.showUnitString
        }
    ];

    return inspectorElements;
};

AbstractPosInteractionModel.prototype.getSnapSet = function (type) {
    var snapSet = new SnapSet();

    switch (type) {
        case SnapLineType.FROM:
            snapSet.add(this.data.pos(), 1);
            break;
        case SnapLineType.TO:
            snapSet.addHor(this.data.pos(), 1);
            snapSet.addVer(this.data.pos(), 1);
            break;
    }

    return snapSet;
};

AbstractPosInteractionModel.prototype.pos = function (pos) {
    return this.data.pos(pos);
};

AbstractPosInteractionModel.prototype.angle = function(angle) {
    return 0;
};

AbstractPosInteractionModel.prototype.rotate = function (angle, center) {
    this.data.rotate(angle, center);
};

AbstractPosInteractionModel.prototype.width = function(width) {
    return 0;
};

AbstractPosInteractionModel.prototype.height = function(height) {
    return 0;
};

